/* =========================================================
   VERSUS · Ventana de tecnologías (compartida)
   - VSTech.open(titulo, info): abre la ventana.
   - VSTech.parse(html): lee "Tecnología y Rendimiento", "Ideal para" y "Composición"
     de la descripción de un producto.
   - Historia de Colecciones (dialog.vs-st): agrega el botón "Tecnologías" sobre la foto
     de la prenda que se está viendo.
   - Página de producto: agrega el botón sobre la foto principal.
   ========================================================= */
(function () {
  if (window.VSTech) return;

  var ICONS = {
    drop: '<path d="M12 3.5c3.2 3.8 5.6 6.8 5.6 9.7a5.6 5.6 0 0 1-11.2 0c0-2.9 2.4-5.9 5.6-9.7z"/><path d="M9.4 13.6a2.6 2.6 0 0 0 2.6 2.6"/>',
    stretch: '<path d="M3.5 12h17"/><path d="M7 8.5L3.5 12 7 15.5"/><path d="M17 8.5l3.5 3.5-3.5 3.5"/>',
    core: '<circle cx="12" cy="12" r="8.5"/><circle cx="12" cy="12" r="4.5"/><circle cx="12" cy="12" r="1"/>',
    shield: '<path d="M12 3.5l7 2.8v5.2c0 4.3-2.9 7.6-7 9-4.1-1.4-7-4.7-7-9V6.3z"/><path d="M9 12l2 2 4-4"/>',
    bolt: '<path d="M13 3L5 13.5h6l-1 7.5 8-10.5h-6z"/>',
    lock: '<rect x="5" y="10.5" width="14" height="10" rx="2"/><path d="M8.5 10.5V7.5a3.5 3.5 0 0 1 7 0v3"/>',
    person: '<circle cx="12" cy="7" r="3"/><path d="M5.5 20.5c.8-3.8 3.4-6 6.5-6s5.7 2.2 6.5 6"/>',
    pocket: '<path d="M5 4.5h14v8.5a7 7 0 0 1-14 0z"/><path d="M5 8.5h14"/>',
    spark: '<path d="M12 3.5l2 5.5 5.5 2-5.5 2-2 5.5-2-5.5-5.5-2 5.5-2z"/>'
  };
  var SPARK = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round" aria-hidden="true">' + ICONS.spark + '</svg>';

  function iconFor(s) {
    s = s.toLowerCase();
    if (/dry|seca/.test(s)) return 'drop';
    if (/adaptive|compres/.test(s)) return 'core';
    if (/flex|panel|rasg|inserci/.test(s)) return 'shield';
    if (/frame|ensambl|grade/.test(s)) return 'bolt';
    if (/grip|antidesliz/.test(s)) return 'lock';
    if (/stretch|elástic|elastic/.test(s)) return 'stretch';
    if (/unisex|horma/.test(s)) return 'person';
    if (/bolsillo|diseño funcional/.test(s)) return 'pocket';
    return 'spark';
  }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function cap(s) { s = s.trim(); return s.charAt(0).toUpperCase() + s.slice(1); }
  /* Deja solo la idea principal: corta antes de "que ..." o de la primera coma */
  function short(s) { s = s.replace(/\.\s*$/, ''); var m = s.split(/\s+que\s+|,\s*/)[0]; return cap(m || s); }

  function parse(html) {
    var doc = new DOMParser().parseFromString(html || '', 'text/html'), out = { k: [], i: [], c: '' };
    [].slice.call(doc.querySelectorAll('p')).forEach(function (p) {
      var t = p.textContent.trim();
      if (/^tecnolog/i.test(t)) {
        var ul = p.nextElementSibling;
        while (ul && ul.tagName !== 'UL') ul = ul.nextElementSibling;
        if (ul) {
          [].slice.call(ul.querySelectorAll('li')).forEach(function (li) {
            var b = li.querySelector('b,strong'), name = b ? b.textContent : '', rest = li.textContent;
            if (name) rest = rest.slice(rest.indexOf(name) + name.length);
            name = name.replace(/[:®]/g, '').replace(/^sistema\s+/i, '').trim();
            rest = rest.replace(/^\s*:\s*/, '').trim();
            if (name) out.k.push({ n: name, d: short(rest), ic: iconFor(name + ' ' + rest) });
          });
        }
      } else if (/^ideal para/i.test(t)) {
        out.i = t.replace(/^ideal para\s*:?\s*/i, '').replace(/\.\s*$/, '').split(/,\s*|\s+y\s+/).map(cap).filter(Boolean);
      } else if (/^composici/i.test(t)) {
        out.c = t.replace(/^composici[oó]n\s*:?\s*/i, '').replace(/\.\s*$/, '').replace(/\s*%/g, '%').replace(/,\s*/g, ' · ');
      }
    });
    return out;
  }

  /* ---------- Ventana ---------- */
  var TX = null, lastFocus = null, onClose = null;
  function build() {
    if (TX) return TX;
    TX = document.createElement('div');
    TX.className = 'vs-tx';
    TX.hidden = true;
    TX.setAttribute('role', 'dialog');
    TX.setAttribute('aria-modal', 'true');
    TX.setAttribute('aria-labelledby', 'vs-tx-title');
    TX.innerHTML =
      '<div class="vs-tx__backdrop" data-tx-close></div>' +
      '<div class="vs-tx__panel">' +
        '<div class="vs-tx__head"><div><p class="vs-tx__eyebrow" data-tx-eyebrow></p><h2 class="vs-tx__title" id="vs-tx-title" data-tx-title></h2></div>' +
        '<button type="button" class="vs-tx__x" data-tx-close aria-label="Cerrar"><svg width="18" height="18" viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M3 3l10 10M13 3L3 13" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg></button></div>' +
        '<div class="vs-tx__body">' +
          '<ul class="vs-tx__list" data-tx-list></ul>' +
          '<div class="vs-tx__block" data-tx-ideal-wrap><p class="vs-tx__label">Ideal para</p><div class="vs-tx__chips" data-tx-ideal></div></div>' +
          '<div class="vs-tx__facts">' +
            '<div class="vs-tx__fact" data-tx-comp-wrap><span class="vs-tx__ficon" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"><path d="M4 7c2.7-2 5.3-2 8 0s5.3 2 8 0"/><path d="M4 12c2.7-2 5.3-2 8 0s5.3 2 8 0"/><path d="M4 17c2.7-2 5.3-2 8 0s5.3 2 8 0"/></svg></span><span data-tx-comp></span></div>' +
            '<div class="vs-tx__care" aria-label="Cuidado">' +
              '<span><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" aria-hidden="true"><path d="M12 3v18M4.2 7.5l15.6 9M4.2 16.5l15.6-9"/></svg>Frío</span>' +
              '<span><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" aria-hidden="true"><rect x="4" y="4" width="16" height="16" rx="2"/><circle cx="12" cy="12" r="4.5"/><path d="M5 5l14 14"/></svg>Sin secadora</span>' +
              '<span><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round" aria-hidden="true"><path d="M7 18.5h10a4 4 0 0 0 .5-8 5.5 5.5 0 0 0-10.6-1.4A4.5 4.5 0 0 0 7 18.5z"/></svg>A la sombra</span>' +
            '</div>' +
          '</div>' +
        '</div>' +
        '<button type="button" class="vs-tx__done" data-tx-close><svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M3 8.5l3.2 3.2L13 4.8" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg><span data-tx-done></span></button>' +
      '</div>';
    document.body.appendChild(TX);
    [].slice.call(TX.querySelectorAll('[data-tx-close]')).forEach(function (b) { b.addEventListener('click', function () { close(); }); });
    stopAll(TX);
    /* Con la ventana abierta, Escape solo la cierra y las flechas no cambian de diseño */
    window.addEventListener('keydown', function (e) {
      if (!TX || TX.hidden) return;
      if (e.key === 'Escape') { e.preventDefault(); e.stopImmediatePropagation(); close(); }
      else if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') { e.stopImmediatePropagation(); }
    }, true);
    return TX;
  }
  function open(title, info, opts) {
    if (!info) return;
    opts = opts || {};
    build();
    TX.querySelector('[data-tx-eyebrow]').textContent = opts.eyebrow || 'Tecnología y rendimiento';
    TX.querySelector('[data-tx-done]').textContent = opts.done || 'Tengo claras las tecnologías';
    TX.querySelector('[data-tx-title]').textContent = title || 'Tecnologías';
    TX.querySelector('[data-tx-list]').innerHTML = info.k.map(function (k) {
      return '<li class="vs-tx__item"><span class="vs-tx__icon" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">' + ICONS[k.ic] + '</svg></span><span class="vs-tx__txt"><strong>' + esc(k.n) + '</strong><span>' + esc(k.d) + '</span></span></li>';
    }).join('');
    TX.querySelector('[data-tx-ideal]').innerHTML = info.i.map(function (x) { return '<span>' + esc(x) + '</span>'; }).join('');
    TX.querySelector('[data-tx-ideal-wrap]').hidden = !info.i.length;
    TX.querySelector('[data-tx-comp]').textContent = info.c;
    TX.querySelector('[data-tx-comp-wrap]').hidden = !info.c;
    lastFocus = opts.returnFocus || document.activeElement;
    onClose = opts.onClose || null;
    /* Dentro de una historia abierta (dialog), la ventana va dentro de ella para quedar encima */
    var host = opts.container || document.body;
    if (TX.parentNode !== host) host.appendChild(TX);
    TX.hidden = false;
    document.documentElement.classList.add('vs-tx-open');
    TX.querySelector('.vs-tx__body').scrollTop = 0;
    TX.querySelector('.vs-tx__x').focus({ preventScroll: true });
  }
  function close(silent) {
    if (!TX || TX.hidden) return;
    TX.hidden = true;
    document.documentElement.classList.remove('vs-tx-open');
    var cb = onClose; onClose = null;
    if (silent === true) return;
    if (cb) cb();
    if (lastFocus && lastFocus.focus && document.contains(lastFocus)) lastFocus.focus({ preventScroll: true });
  }
  function isOpen() { return !!TX && !TX.hidden; }

  /* ---------- Historia de Colecciones (.vs-st) ---------- */
  /* Dentro de la historia abierta: botón "Tecnologías" sobre la foto de la prenda que se ve.
     La información sale de la descripción del producto (/products/x.js). Mientras la ventana
     está abierta, la historia se pausa. */
  var pcache = {};
  function loadProduct(url) {
    url = String(url || '').split('#')[0].split('?')[0].replace(/\/$/, '');
    if (!url) return Promise.reject(new Error('sin url'));
    if (!pcache[url]) {
      pcache[url] = fetch(url + '.js', { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
        .then(function (j) { var x = parse(j.description); x.title = j.title || ''; return x; })
        .catch(function (e) { delete pcache[url]; throw e; });
    }
    return pcache[url];
  }
  function stopAll(el) {
    ['pointerdown', 'pointerup', 'pointercancel', 'click', 'contextmenu', 'touchstart', 'touchend'].forEach(function (ev) {
      el.addEventListener(ev, function (e) { e.stopPropagation(); });
    });
  }
  function enhanceStory(dlg) {
    if (dlg.dataset.tx) return;
    var stage = dlg.querySelector('.vs-st__stage'), cta = dlg.querySelector('.vs-st__cta'), title = dlg.querySelector('.vs-st__title');
    if (!stage || !cta) return;
    dlg.dataset.tx = '1';
    var chip = document.createElement('button');
    chip.type = 'button';
    chip.className = 'vs-tx-chip vs-tx-chip--stage';
    chip.innerHTML = SPARK + '<span>Tecnologías</span>';
    chip.hidden = true;
    stage.appendChild(chip);
    stopAll(chip);
    var cur = null;
    function refresh() {
      var href = cta.getAttribute('href');
      cur = href;
      chip.hidden = true;
      if (!href || href === '#') return;
      loadProduct(href).then(function (info) {
        if (cur === href) chip.hidden = !(info && info.k.length);
      }, function () {});
    }
    new MutationObserver(refresh).observe(cta, { attributes: true, attributeFilter: ['href'] });
    refresh();
    chip.addEventListener('click', function () {
      var href = cta.getAttribute('href');
      loadProduct(href).then(function (info) {
        if (!info || !info.k.length) return;
        /* Pausa la historia como si se mantuviera presionada; al cerrar la ventana, sigue */
        try { stage.dispatchEvent(new PointerEvent('pointerdown', { clientX: 0 })); } catch (e) {}
        open((title && title.textContent.trim()) || '', info, {
          returnFocus: chip,
          container: dlg,
          onClose: function () { try { stage.dispatchEvent(new PointerEvent('pointercancel')); } catch (e) {} }
        });
      }, function () {});
    });
    dlg.addEventListener('close', function () { close(true); });
  }
  /* ---------- Página de producto ---------- */
  /* Botón "Tecnologías" abajo a la izquierda de la foto principal: en el carrusel del celular
     y en la primera foto de la cuadrícula en computador. Solo si el producto tiene tecnologías. */
  function productUrl() {
    var m = location.pathname.match(/\/products\/([^\/?#]+)/);
    return m ? '/products/' + m[1] : '';
  }
  function makeChip(extra) {
    var chip = document.createElement('button');
    chip.type = 'button';
    chip.className = 'vs-tx-chip ' + extra;
    chip.innerHTML = SPARK + '<span>Tecnologías</span>';
    stopAll(chip);
    return chip;
  }
  function enhanceProduct() {
    var url = productUrl();
    if (!url) return;
    var galleries = [].slice.call(document.querySelectorAll('media-gallery')).filter(function (g) {
      return !g.closest('dialog, quick-add-component, .quick-add-modal, .vs-st, .vs-pst');
    });
    if (!galleries.length) return;
    loadProduct(url).then(function (info) {
      if (!info || !info.k.length) return;
      galleries.forEach(function (g) {
        var hosts = [g.querySelector('slideshow-component'), g.querySelector('.media-gallery__grid > li')].filter(Boolean);
        if (!hosts.length) hosts = [g];
        hosts.forEach(function (h) {
          if (h.querySelector(':scope > .vs-tx-chip--pdp')) return;
          h.classList.add('vs-tx-host');
          var chip = makeChip('vs-tx-chip--pdp');
          chip.addEventListener('click', function (e) {
            e.preventDefault();
            open(info.title, info, { returnFocus: chip });
          });
          h.appendChild(chip);
        });
      });
    }, function () {});
  }
  /* Si el tema vuelve a pintar la galería (cambio de variante), el botón se vuelve a poner */
  var pdpTimer = null;
  function watchProduct() {
    if (!productUrl()) return;
    var main = document.getElementById('MainContent') || document.body;
    new MutationObserver(function () {
      clearTimeout(pdpTimer);
      pdpTimer = setTimeout(enhanceProduct, 150);
    }).observe(main, { childList: true, subtree: true });
  }

  function enhance(root) {
    [].slice.call((root || document).querySelectorAll('dialog.vs-st')).forEach(enhanceStory);
    enhanceProduct();
  }
  function init() { enhance(document); watchProduct(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  /* El editor del tema vuelve a pintar secciones: se mejoran de nuevo */
  document.addEventListener('shopify:section:load', function (e) { enhance(e.target); });

  window.VSTech = { open: open, close: close, isOpen: isOpen, parse: parse, spark: SPARK };
})();
